import { request } from '@umijs/max';
import { UploadVo, UrlListPayload, UrlSizeListPayload } from '../HomeTypings';

export namespace HomeFile {
  /**
   * @summary 文件url列表
   * @secure
   */
  export const urlList = async (data: UrlListPayload, params: { [key: string]: any } = {}) => {
    return request<UploadVo[]>(`/home/file/url/list`, {
      method: 'POST',
      data: data,
      ...params,
    });
  };

  /**
   * @summary 文件url列表 [size]
   * @secure
   */
  export const urlSizeList = async (
    size: 'O' | 'L' | 'M' | 'S' | 'XS',
    data: UrlSizeListPayload,
    params: { [key: string]: any } = {},
  ) => {
    return request<UploadVo[]>(`/home/file/url/list/${size}`, {
      method: 'POST',
      data: data,
      ...params,
    });
  };

  /**
   * @summary 文件url
   * @secure
   */
  export const url = async (id: number, params: { [key: string]: any } = {}) => {
    return request<UploadVo>(`/home/file/url/${id}`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 文件url [SIZE]
   * @secure
   */
  export const urlSize = async (
    id: number,
    size: 'O' | 'L' | 'M' | 'S' | 'XS',
    params: { [key: string]: any } = {},
  ) => {
    return request<UploadVo>(`/home/file/url/${id}/${size}`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 显示文件
   * @secure
   */
  export const fileResponse = async (id: number, params: { [key: string]: any } = {}) => {
    return request<void>(`/home/file/response/${id}`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 显示文件 [SIZE]
   * @secure
   */
  export const fileResponseSize = async (
    id: number,
    size: 'O' | 'L' | 'M' | 'S' | 'XS',
    params: { [key: string]: any } = {},
  ) => {
    return request<void>(`/home/file/response/${id}/${size}`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 下载文件
   * @secure
   */
  export const fileDownload = async (id: number, params: { [key: string]: any } = {}) => {
    return request<void>(`/home/file/download/${id}`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 下载文件 [SIZE]
   * @secure
   */
  export const fileDownloadSize = async (
    id: number,
    size: 'O' | 'L' | 'M' | 'S' | 'XS',
    params: { [key: string]: any } = {},
  ) => {
    return request<void>(`/home/file/download/${id}/${size}`, {
      method: 'GET',
      ...params,
    });
  };
}

export default HomeFile;

export const urlList = HomeFile.urlList;
export const urlSizeList = HomeFile.urlSizeList;
export const url = HomeFile.url;
export const urlSize = HomeFile.urlSize;
export const fileResponse = HomeFile.fileResponse;
export const fileResponseSize = HomeFile.fileResponseSize;
export const fileDownload = HomeFile.fileDownload;
export const fileDownloadSize = HomeFile.fileDownloadSize;
